/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * GLOBAL = all users. GAME = tied to a specific game. HUB = hub members only.
 * @export
 */
export const SeasonScopeType = {
    GLOBAL: 'GLOBAL',
    GAME: 'GAME',
    HUB: 'HUB'
} as const;
export type SeasonScopeType = typeof SeasonScopeType[keyof typeof SeasonScopeType];


export function instanceOfSeasonScopeType(value: any): boolean {
    for (const key in SeasonScopeType) {
        if (Object.prototype.hasOwnProperty.call(SeasonScopeType, key)) {
            if (SeasonScopeType[key as keyof typeof SeasonScopeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SeasonScopeTypeFromJSON(json: any): SeasonScopeType {
    return SeasonScopeTypeFromJSONTyped(json, false);
}

export function SeasonScopeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeasonScopeType {
    return json as SeasonScopeType;
}

export function SeasonScopeTypeToJSON(value?: SeasonScopeType | null): any {
    return value as any;
}

export function SeasonScopeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SeasonScopeType {
    return value as SeasonScopeType;
}

